module.exports = __webpack_public_path__ + "static/media/36.7173e928.jpg";